// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XAcX0aoWl_IOg4FftjlN {
  color: var(--campaign-color-timer-starts);
  font-family: var(--campaign-info-dynamic-value-font-family, var(--font-family-primary, inherit));
  font-size: 13px;
  font-style: normal;
  font-weight: var(--campaign-info-dynamic-value-font-weight, 700);
  text-transform: capitalize;
  white-space: nowrap;
  line-height: 1;
  margin-left: 0.23em;
  /*   2px positioning nudge + cap-alphabetic text-box trim (see campaign-variables.module.css).
       Same dead-space issue as the prize amount: the value is digits/colons only, so line-height: 1
       reserves descender space the font never uses. Margin trim replaces the old Chromium-only
       @supports (text-box-trim) block so the fix also lands in Firefox / older browsers.
       
       Only applies to --font-family-primary: a variant that overrides
       --campaign-info-dynamic-value-font-family must also reset the two margin vars below. */
  margin-top: var(--campaign-info-dynamic-value-margin-top, calc(2px + var(--campaign-futura-trim-top)));
  margin-bottom: var(--campaign-info-dynamic-value-margin-bottom, var(--campaign-futura-trim-bottom));
}
.XAcX0aoWl_IOg4FftjlN[data-view='multi'] {
  font-size: 13.5px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .XAcX0aoWl_IOg4FftjlN[data-view] {
    font-size: 9px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .XAcX0aoWl_IOg4FftjlN[data-view='multi'] {
    font-size: 7px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .XAcX0aoWl_IOg4FftjlN[data-view='multi'] {
    font-size: 7px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/BottomCardInfo/components/ui/CampaignInfoSuffixes/ClaimedWinCurrency/ClaimedWinCurrency.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,gGAAgG;EAChG,eAAe;EACf,kBAAkB;EAClB,gEAAgE;EAChE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB;;;;;;6FAM2F;EAC3F,sGAAsG;EACtG,mGAAmG;AACrG;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;AAAA;EACE;IACE,cAAc;EAChB;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,cAAc;EAChB;AACF;AAAA;AAAA;AAAA","sourcesContent":[".currency {\n  color: var(--campaign-color-timer-starts);\n  font-family: var(--campaign-info-dynamic-value-font-family, var(--font-family-primary, inherit));\n  font-size: 13px;\n  font-style: normal;\n  font-weight: var(--campaign-info-dynamic-value-font-weight, 700);\n  text-transform: capitalize;\n  white-space: nowrap;\n  line-height: 1;\n  margin-left: 0.23em;\n  /*   2px positioning nudge + cap-alphabetic text-box trim (see campaign-variables.module.css).\n       Same dead-space issue as the prize amount: the value is digits/colons only, so line-height: 1\n       reserves descender space the font never uses. Margin trim replaces the old Chromium-only\n       @supports (text-box-trim) block so the fix also lands in Firefox / older browsers.\n       \n       Only applies to --font-family-primary: a variant that overrides\n       --campaign-info-dynamic-value-font-family must also reset the two margin vars below. */\n  margin-top: var(--campaign-info-dynamic-value-margin-top, calc(2px + var(--campaign-futura-trim-top)));\n  margin-bottom: var(--campaign-info-dynamic-value-margin-bottom, var(--campaign-futura-trim-bottom));\n}\n.currency[data-view='multi'] {\n  font-size: 13.5px;\n}\n@media (--campaign-mobile) {\n  .currency[data-view] {\n    font-size: 9px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .currency[data-view='multi'] {\n    font-size: 7px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"currency": `XAcX0aoWl_IOg4FftjlN`
};
export default ___CSS_LOADER_EXPORT___;
